import type { MESSAGE_ERROR_HTTP, STATUS_CODE_ALLOW } from "@/interfaces/http-client"
import { getUUID } from "@/utils/commoms";
import { UserAuthUtil } from "@/utils/userAuth";
import axios from "axios";

export const getMessageError = (error: unknown, messageCustom: Partial<MESSAGE_ERROR_HTTP>, 
    fieldError:string='mensaje'): string => {
    let messageError:string = messageCustom['default'] || '';
    if (axios.isAxiosError(error)) {
        if (error.response) {
            const messageErrorCustom = messageCustom[String(error.response.status) as STATUS_CODE_ALLOW];
            if (messageErrorCustom) return messageErrorCustom;

            switch (error.response.status) {
                case 400:
                    messageError = error.response.data[fieldError] || error.response.data.error?.[fieldError] || "Error en la solicitud";
                    break;
                case 404:
                    messageError = error.response.data[fieldError] || "Datos no encontrado";
                    break;
                case 500:
                    messageError = error.response.data[fieldError] || "Error interno del servidor";
                    break;
                default:
                    messageError = `Error del servidor: ${error.response.status} - ${error.response.data?.mensaje || error.response.statusText}`;
            }
        } else if (error.request) {
            messageError = "No se pudo conectar con el servidor. Verifique su conexión a internet.";
        }

    }

    return messageError;
}

export const getApiUxHeaders = () => {
    return {
        'Authorization': `Bearer ${UserAuthUtil.getAccessToken()}`,
        'Transaccion-Id': getUUID(),
        'Nombre-Aplicacion': import.meta.env.VITE_APPLICATION_NAME,
        'Aplicacion-Id': 'PESV',
        'Usuario-Consumidor-Id': `${UserAuthUtil.getUserOnPremise()}`,
        'Nombre-Servicio-Consumidor': 'Portal de Emision y Suscripcion',
        'Ocp-Apim-Subscription-Key': import.meta.env.VITE_SUBSCRIPTION_KEY
    }
}

export const getApiUxHeadersOld = () => {
    return {
        'Authorization': `Bearer ${UserAuthUtil.getAccessToken()}`,
        'correlationid': getUUID(),
        'idTransaccion': '761770302',
        'procesoNegocio': 'Suscripcion',
        'Ocp-Apim-Subscription-Key': 'd2240fe07448479590c556af4f691654',
        'nombreAplicacion': import.meta.env.VITE_APPLICATION_NAME
    }
}